<script>
    import TileHosting from './TileCarePlan.svelte'
    import { selectedCarePlan } from '../stores.js';
    import TileCarePlan from './TileCarePlan.svelte';

    let carePlans = [
        {
            'title' : 'Basic',
            'price' : 20,
            'description' : 'Le minimum<br>pour les sites non critiques',
            'security' : 1,
            'services' : 1,
            'detailServices' : `
                Contribution aux licences<br>
                Firewall <b>basique</b><br>
                <b>1</b> sauvegarde par jour<br>
                <b>30</b> sauvegardes conservées<br>
                <b>275€</b> /mise à jour intégrale<br>
                —<br>
                —<br>
                —
            `,
            'detailHelp' : `
                Support via <b>email</b><br>
                Priorité support : <b>basse</b><br>
                Frais de remise en ligne <b>150€</b><br>
                Intervention garantie sous <b>5 jours</b><br>
                —<br>
                _
            `,
        },
        {
            'isFeatured' : true,
            'title' : 'Starter',
            'price' : 50,
            'description' : 'Un bon départ<br>pour les TPE',
            'security' : 2,
            'services' : 2,
            'detailServices' : `
                Contribution aux licences<br>
                Firewall et Antivirus <b>premium</b><br>
                <b>1</b> sauvegarde par jour<br>
                <b>90</b> sauvegardes conservées<br>
                <b>2</b>mises à jour intégrales par an<br>
                <b>alertes</b> en cas de site indisponible<br>
                —<br>
                —
            `,
            'detailHelp' : `
                Support via <b>email</b><br>
                Priorité support : <b>normale</b><br>
                Frais de remise en ligne <b>50€</b><br>
                Intervention garantie sous <b>3 jours</b><br>
                Interventions offertes <b>15min/mois</b><br>
                Strategy session <b>1/an</b></br>
            `,
        },
        {
            'title' : 'Pro',
            'price' : 85,
            'description' : 'Très bon ratio service / prix<br>pour les pros exigeants',
            'security' : 3,
            'services' : 3,
            'detailServices' : `
                Contribution aux licences <b>premium</b><br>
                Firewall et Antivirus <b>premium</b><br>
                <b>1</b> sauvegarde par jour<br>
                <b>180</b> sauvegardes conservées<br>
                <b>3</b>mises à jour intégrales par an<br>
                <b>alertes</b> en cas de site indisponible<br>
                <b>99% de disponibilité garantie</b><br>
                —
            `,
            'detailHelp' : `
                Support via <b>email + téléphone</b><br>
                Priorité support : <b>haute</b><br>
                Frais de remise en ligne <b>gratuit</b><br>
                Intervention garantie sous <b>48h</b><br>
                Interventions offertes <b>30min/mois</b><br>
                Strategy session <b>2/an</b></br>
            `,
        },
        {
            'title' : 'Premium',
            'price' : 145,
            'description' : 'Excellente protection et suivi<br>pour booster votre activité.',
            'security' : 5,
            'services' : 4,
            'detailServices' : `
                Contribution aux licences <b>premium</b><br>
                Firewall et Antivirus <b>premium</b><br>
                <b>1</b> sauvegarde par jour<br>
                <b>6</b> mois de sauvegardes conservées<br>
                <b>4</b>mises à jour intégrales par an<br>
                <b>alertes</b> en cas de site indisponible<br>
                <b>99.9% de disponibilité garantie</b><br>
                <b>updates d’urgence</b>
            `,
            'detailHelp' : `
                Support via <b>email + téléphone</b><br>
                Priorité support : <b>premium</b><br>
                Frais de remise en ligne <b>gratuit</b><br>
                Intervention garantie sous <b>24h</b><br>
                Interventions offertes <b>1h/mois</b><br>
                Strategy session <b>4/an</b></br>
            `,
        },
        {
            'title' : 'Unlimited',
            'price' : 275,
            'description' : 'Elimination maximale des risques pour site critique',
            'security' : 5,
            'services' : 5,
            'detailServices' : `
                Contribution aux licences <b>premium</b><br>
                Firewall et Antivirus <b>premium</b><br>
                <b>1</b> sauvegarde par <b>heure</b><br>
                <b>90</b> sauvegardes conservées<br>
                <b>1</b>mise à jour intégrale par mois<br>
                <b>alertes</b> en cas de site indisponible<br>
                <b>99.9% de disponibilité garantie</b><br>
                <b>updates d’urgence</b>
            `,
            'detailHelp' : `
                Support via <b>email + téléphone</b><br>
                Priorité support : <b>premium</b><br>
                Frais de remise en ligne <b>gratuit</b><br>
                Intervention garantie sous <b>12h</b><br>
                Interventions offertes <b>2h/mois</b><br>
                Strategy session <b>1/mois</b></br>
            `,
        },
    ]

    // To preselect the hosting plan :
    $selectedCarePlan = carePlans[1];
    
    // let selectedDynamic


</script>

<div class="care-plans-tiles">
    {#each carePlans as plan}
        <TileCarePlan {plan}/>
    {/each}
</div>



<style>
    .care-plans-tiles{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: 24px;
    }
    @media all and (max-width: 900px) {
        .care-plans-tiles {
            grid-template-columns: repeat(1, 100%);
            row-gap: 24px;
            max-width: 400px;
            margin: auto;
        }
    }
</style>